module.exports = __webpack_public_path__ + "img/operationCapacity6.c3bb4d5c.png";